<template>
  <div class="soar-container flex flex-col gap-y-8 min-h-[70vh]">
    <HeaderTypo
      as="h3"
      class="font-thin leading-6 !text-2xl p-5 bg-[#fcfdfd] border-b border-[#dee5e7] !text-brand-black-secondary"
    >
      {{ $t('register') }}
    </HeaderTypo>

    <FormWrapper class="flex-1 flex flex-col gap-y-3">
      <template #header>
        <StepperVue :steps="steps" v-model="activeStepIndex" disabled></StepperVue>
      </template>
      <EidStep1
        v-if="activeStepIndex === 0"
        :form="step1Form"
        @onBack="handleBackClick"
        @onNext="handleStep1Submit"
      ></EidStep1>
      <EidStep2
        v-if="activeStepIndex === 1 && step1Response.results.isValid"
        :data="step1Response"
        @onBack="handleBackClick"
        @onNext="handleStep2Submit"
      ></EidStep2>
      <EidStep3
        v-if="activeStepIndex === 2"
        :data="step2Response"
        @onBack="handleBackClick"
        @onNext="handleStep3Submit"
      ></EidStep3>
    </FormWrapper>
  </div>
</template>

<script setup>
import FormWrapper from '@/components/Form/FormWrapper.vue'
import StepperVue from '@/components/Ui/Stepper.vue'
import EidStep1 from '@/views/individuals/onboarding/eid/_step1.vue'
import EidStep2 from '@/views/individuals/onboarding/eid/_step2.vue'
import EidStep3 from '@/views/individuals/onboarding/eid/_step3.vue'
import axios from '@/services'
import { notify } from 'notiwind'

import router from '@/router'
import { useForm } from 'vee-validate'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()
const activeStepIndex = ref(0)

const step1Response = ref()
const step2Response = ref()

const steps = computed(() => {
  return ['IdentityNumber', 'Verfication', 'registeration']
})

const step1Form = useForm({
  initialValues: {
    // eid: '784196253658270'
  }
})

const handleBackClick = () => {
  if (activeStepIndex.value > 0) {
    activeStepIndex.value -= 1
    return
  }

  router.back()
}

// const onNext = async () => {
//   if (activeStepIndex.value === 0) {
//     await handleStep1Submit()
//   }

//   if (activeStepIndex.value === 1) {
//     await handleStep2Submit()
//   }
// }

const handleStep1Submit = async () => {
  step1Form.setTouched(true)
  const validationResult = await step1Form.validate()
  if (!validationResult.valid) return

  const results = await axios.post(
    '/api/user/individual/identityNumber/validateForRegisteration',
    step1Form.values.eid.replaceAll('-', ''),
    {
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json, text/plain',
        ValidateRegisterationKey: 'ERTb456456456V845liZAj1Pm3cOtE98a='
      }
    }
  )

  if (results.isValid) {
    step1Response.value = {
      eid: step1Form.values.eid,
      results
    }
    activeStepIndex.value += 1
    return
  }

  notify(
    {
      group: 'error',
      text: results.reason
    },
    6000
  )
}

const handleStep2Submit = async (response) => {
  step2Response.value = response
  activeStepIndex.value += 1
}
</script>

<style lang="scss" scoped></style>
